// import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icons } from "../../Icons";
import SubMenu from "./subMenu";
import Buttons from "../../Buttons";
import { IWantToCombo } from "../../../molecules/IWantToCombo";
import { MEMBERSHIPTYPE, MEMBERTYPE } from "../../../constants/constants";
import { useSelector } from "react-redux";
import { isHybridMember } from "../../../helpers/helpers";

export function MobileNavigation({ badgeCount, memberTypeObj, logoutUser }) {
  const { potData } = useSelector((state) => state.totalPotInfo);
  const navigate = useNavigate();
  const savingsSubmenu = {
    heading: "Savings",
    menu: [
      { menu: "Summary", link: "/savings?tab=summary" },
      //TODO - Hiding track my value, as its considered as not a day1 requirement
      // { menu: "Performance", link: "/savings?tab=trackMyValue" },
      { menu: "Transactions", link: "/savings?tab=transactions" },
    ],
  };

  const manageSubmenu = {
    heading: "Manage",
    menu: [
      { menu: "Contributions", link: "/manage?tab=contributions" },
      { menu: "Investments", link: "/manage?tab=investments" },
      { menu: "Withdrawals", link: "/manage?tab=withdrawals" },
      { menu: "Other pots", link: "/manage?tab=otherPots" },
    ],
  };

  const planSubmenu = {
    heading: "Plan",
    menu: [
      { menu: "Target retirement age", link: "/plan?tab=tra" },
      { menu: "Retirement explorer", link: "/plan?tab=retirementExplorer" },
      {
        menu: "Plan your future calculator",
        link: "/plan?tab=futureCalculator",
      },
      // TODO - RA disable this in PROD env
      // {
      //   menu: "Retirement application",
      //   link: "/plan?tab=retirementApplication",
      // },
      { menu: "Leaving TPT", link: "/plan?tab=leavingTpt" },
    ],
  };
  if (isHybridMember(memberTypeObj?.membershipType)) {
    planSubmenu.menu = planSubmenu.menu.filter(
      (item) =>
        item.menu != "Retirement explorer" &&
        item.menu != "Plan your future calculator", //eslint-disable-line
    );
  }
  if (
    memberTypeObj?.memberType === MEMBERTYPE.ACTIVE ||
    memberTypeObj?.memberType === MEMBERTYPE.ACTIVE_SAVINGS ||
    memberTypeObj?.memberType === MEMBERTYPE.DEFERRED ||
    memberTypeObj?.memberType === MEMBERTYPE.DEFERRED_SAVINGS
  ) {
    manageSubmenu.menu = manageSubmenu.menu.filter((item) => {
      return item.menu != "Withdrawals";
    });
  }
  if (memberTypeObj?.memberType === MEMBERTYPE.INACTIVE) {
    if (savingsSubmenu.heading.toLocaleLowerCase() == "savings") {
      savingsSubmenu.menu = savingsSubmenu.menu.filter((item) => {
        return item.menu != "Summary" && item.menu != "Performance";
      });
    }
    if (manageSubmenu.heading.toLocaleLowerCase() == "manage") {
      manageSubmenu.menu = manageSubmenu.menu.filter((item) => {
        return (
          (item.menu !== "Contributions" ||
            memberTypeObj?.membershipType?.[0] ===
              MEMBERSHIPTYPE.DC_AVC_PAYER ||
            memberTypeObj?.membershipType?.[0] === MEMBERSHIPTYPE.DC_TVIN) &&
          item.menu !== "Investments" &&
          item.menu !== "Withdrawals"
        );
      });

      if (potData?.data?.drawdownPots?.totalDrawdownValue > 0) {
        manageSubmenu.menu.push({ menu: "Withdrawals" });
      }
    }
    if (planSubmenu.heading.toLowerCase() === "plan") {
      planSubmenu.menu = planSubmenu.menu.filter((item) => {
        return (
          item.menu !== "Target retirement age" &&
          item.menu !== "Retirement explorer" &&
          item.menu !== "Retirement application" &&
          item.menu !== "Leaving TPT"
        );
      });
    }
  }
  if (memberTypeObj?.memberType === MEMBERTYPE.PENSIONER_DRAWDOWN) {
    planSubmenu.menu = planSubmenu.menu.filter(
      (item) => item.menu != "Target retirement age" //eslint-disable-line
    );
  }
  if (
    memberTypeObj?.memberType === MEMBERTYPE.PENSIONER_DRAWDOWN ||
    memberTypeObj?.memberType === MEMBERTYPE.DEPENDENT_PENSIONER_DRAWDOWN
  ) {
    planSubmenu.menu = planSubmenu.menu.filter(
      (item) => item.menu != "Plan your future calculator" //eslint-disable-line
    );
  }

  const accountSubmenu = {
    heading: "Account",
    menu: [
      { menu: "Account details", link: "/account-details?tab=personalDetails" },
      { menu: "Beneficiaries", link: "/beneficiaries" },
      { menu: "Messages & documents", link: "/messages-and-documents" },
      { menu: "Communication settings", link: "/communication-preferences" },
      { menu: "Account settings", link: "/account-settings" },
    ],
  };

  const [showSubmenu, setShowSubmenu] = useState({});
  const [expanded, setExpanded] = useState(false);
  const [submenu, setSubmenu] = useState(true);
  const [mainMenu, setMainMenu] = useState(true);

  const closeNavbar = () => {
    setExpanded(false);
  };

  const savingsHandle = (e) => {
    setShowSubmenu(savingsSubmenu);
    setSubmenu(!submenu);
    setMainMenu(false);
    e.stopPropagation();
  };

  const manageHandle = (e) => {
    setShowSubmenu(manageSubmenu);
    setSubmenu(!submenu);
    setMainMenu(false);
    e.stopPropagation();
  };

  const planHandle = (e) => {
    setShowSubmenu(planSubmenu);
    setSubmenu(!submenu);
    setMainMenu(false);
    e.stopPropagation();
  };

  const accountHandle = (e) => {
    setShowSubmenu(accountSubmenu);
    setSubmenu(!submenu);
    setMainMenu(false);
    e.stopPropagation();
  };

  const backButton = (e) => {
    setSubmenu(!submenu);
    setMainMenu(true);
    e.stopPropagation();
  };
  const navigateHome = () => {
    navigate("/");
  };

  return (
    <>
      {
        <Navbar
          expand={false}
          expanded={expanded}
          className="bg-body-tertiary mb-3 d-block d-sm-none fixed-top"
        >
          <Container fluid>
            <Navbar.Brand href="" className="tpt-brand">
              <Icons
                iconname="logo-white"
                variant="logo"
                clickHandler={navigateHome}
              />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls={"offcanvasNavbar-expand"}
              onClick={() => setExpanded(!expanded)}
            >
              <Icons
                iconname="navigation-burger-menu-text"
                variant="icon-sixty-four-px"
              />
            </Navbar.Toggle>
            <Navbar.Offcanvas
              id={"offcanvasNavbar-expand"}
              aria-labelledby={"offcanvasNavbarLabel-expand"}
              placement="end"
            >
              {mainMenu ? (
                <>
                  <Offcanvas.Header closeButton onClick={closeNavbar}>
                    <Offcanvas.Title
                      id={"offcanvasNavbarLabel-expand"}
                      className="tpt-title"
                    >
                      <div>
                        <Icons
                          iconname="logo-white"
                          variant="logo"
                          clickHandler={navigateHome}
                        />
                      </div>
                    </Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Nav
                      className="justify-content-end flex-grow-1 pe-3"
                      onClick={closeNavbar}
                    >
                      <Nav.Link as={Link} to="/" forceRefresh={false}>
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-home"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Home</span>
                          </div>
                        </div>
                      </Nav.Link>
                      <Nav.Link onClick={savingsHandle}>
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-savings"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Savings</span>
                          </div>
                          <div className="arrow">
                            <Icons
                              iconname="chevron-right-white"
                              variant="icon-twenty-four-px"
                            />
                          </div>
                        </div>
                      </Nav.Link>
                      <Nav.Link onClick={manageHandle}>
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-manage"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Manage</span>
                          </div>
                          <div className="arrow">
                            <Icons
                              iconname="chevron-right-white"
                              variant="icon-twenty-four-px"
                            />
                          </div>
                        </div>
                      </Nav.Link>
                      <Nav.Link onClick={planHandle}>
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-plan"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Plan</span>
                          </div>
                          <div className="arrow">
                            <Icons
                              iconname="chevron-right-white"
                              variant="icon-twenty-four-px"
                            />
                          </div>
                        </div>
                      </Nav.Link>
                      <Nav.Link as={Link} to="/learn">
                        <div className="container">
                          <div>
                            <Icons
                              iconname="navigation-learn"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Learn</span>
                          </div>
                        </div>
                      </Nav.Link>
                      <hr style={{ color: "white", marginLeft: "15px" }}></hr>
                      <Nav.Link
                        as={Link}
                        to="/messages-and-documents?tab=messages"
                      >
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-messages"
                              variant="icon-twenty-four-px"
                              badgeCount={badgeCount}
                            />
                            <span className="spacing">Messages</span>
                          </div>
                        </div>
                      </Nav.Link>
                      <Nav.Link onClick={accountHandle}>
                        <div className="container">
                          <div className="menuSpacing">
                            <Icons
                              iconname="navigation-account"
                              variant="icon-twenty-four-px"
                            />
                            <span className="spacing">Account</span>
                          </div>
                          <div className="arrow">
                            <Icons
                              iconname="chevron-right-white"
                              variant="icon-twenty-four-px"
                            />
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav>
                    <div style={{ paddingTop: "60px", paddingLeft: "10px" }}>
                      <Container className="d-flex mb-3">
                        <IWantToCombo
                          closeNabar={closeNavbar}
                          memberObj={memberTypeObj}
                        />
                      </Container>
                      <Container className="d-flex justify-content-center mb-4">
                        <Buttons
                          className="outline-success-mob-nav"
                          name="Sign out"
                          handleClick={logoutUser}
                        />
                      </Container>
                    </div>
                  </Offcanvas.Body>
                </>
              ) : (
                ""
              )}
              {submenu ? (
                ""
              ) : (
                <>
                  <SubMenu
                    backButton={backButton}
                    items={showSubmenu}
                    closeNavbar={closeNavbar}
                  />
                </>
              )}
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      }
    </>
  );
}
